export const APP_STORE_URL =
  "https://apps.apple.com/us/app/payment-pulse/id6793563761";
